/* eslint-disable */
<template>
  <md-modal-dialog
    class="md-dialog"
    @md-opened="event = 'md-opened'"
    :md-click-outside-to-close="false"
    @md-clicked-outside="onModalClose"
  >
    <ModalWrapper>
      <div class="modal" role="dialog" aria-modal="true" aria-live="assertive" aria-labelledby="t-c-title">
        <button class="btn-close" aria-label="Close" @click="onModalClose">
          <IconCross />
        </button>
        <h1 id="t-c-title" class="t-center">Singapore Trip Planner Powered by <i>Mobi</i></h1>
        <h2 class="t-center">FAQs/Program Terms</h2>
        <div>
          <h3>What is the Singapore Trip Planner?</h3>
          <p>
            Singapore Trip Planner (singapore.takemobi.com) is a free online planning tool that can make travel
            recommendations and help you build a personalized itinerary for future travel to Singapore. This tool helps
            solve common trip planning pain points using smart planning technology powered by Mobi – making it more
            seamless than ever to plan your trip!
          </p>
          <p>
            With the Singapore Trip Planner, you can book flights, hotels, dining reservations, and activities through
            click-outs to relevant trusted third-party booking websites, like Expedia and Tripadvisor, that will be
            pre-populated from the personalized itinerary the application creates.
          </p>

          <h3>The Singapore Trip Planner site states that it is “powered by Mobi”. What is Mobi?</h3>
          <p>
            Mobi Systems, Inc. (“Mobi”) (takemobi.com), a Massachusetts, USA, corporation, powers, operates and controls
            the singapore.takemobi.com website and planning technology behind the Singapore Trip Planner.
          </p>

          <h3>
            I arrived on the Singapore Trip Planner website via a link from VisitSingapore.com. Is the Singapore Trip
            Planner affiliated with VisitSingapore.com or the Singapore Tourism Board?
          </h3>
          <p>
            The Singapore Trip Planner is not owned, supported, endorsed or controlled in any way by VisitSingapore.com
            or the Singapore Tourism Board. While the Singapore Tourism Board may share or obtain certain information
            and data from Mobi to provide guidance on adapting the Singapore Trip Planner to best serve travelers to
            Singapore, the Singapore Trip Planner website is fully owned and operated by Mobi and any linked sites or
            web feeds are not under the control of the Singapore Tourism Board and the Singapore Tourism Board is not
            responsible for the contents of any linked site, any web feed, or any link contained in a linked site and
            web feed, or any changes or updates to such sites or contents from web feeds. Please refer to the Terms of
            Use for more details.
          </p>

          <h3>Which entity owns data that is created from my use of the Singapore Trip Planner?</h3>
          <p>
            Mobi collects and owns all data that is generated from your use of the Singapore Trip Planner. No personally
            identifiable information (“PII”) is being collected by Mobi from your use of the Singapore Trip Planner
            aside from any PII that you share in the natural language prompt on the homepage, and Mobi does not collect
            PII from any third party, including VisitSingapore.com or third-party booking websites linked on the
            Singapore Trip Planner. Any user data that may be shared with Singapore Tourism Board will be aggregated and
            will not contain any PII.
          </p>

          <h3>How can I book flights, hotels, dining reservations and activities on the Singapore Trip Planner?</h3>
          <p>
            Once you are satisfied with your trip itinerary, you can click on the “Book Trip” button. Then, you will see
            the links to book directly on the relevant third-party websites. You cannot book travel directly on the
            Singapore Trip Planner website.
          </p>
          <p>
            For example, for flight and hotel bookings, you may see a link to Expedia.com. For activity bookings, you
            may see a link to TripAdvisor.com. Once you have booked through these relevant third-party websites, you
            will receive a confirmation email(s) from the respective third parties based on what you have booked.
          </p>

          <h3>How do I make a change to my plan or itinerary after I book?</h3>
          <p>
            While the Singapore Trip Planner helps surface booking opportunities, the actual bookings are made with the
            relevant third-parties. Any changes must be made directly with the relevant third party. We recommend
            reaching out to them or searching their websites for more information.
          </p>
          <p>
            Please keep in mind that the ability to make changes to a booking is subject to the change policies and
            other relevant terms of the applicable airline, hotel, dining, and activities booking service.
          </p>

          <h3>How accurate is the information served out in the Singapore trip planner?</h3>
          <p>
            We recommend users to review and verify the generated plans for their specific needs, preferences, and
            safety considerations, amongst other considerations.
          </p>
          <p>
            Neither Mobi nor the Singapore Tourism Board assume any liability for the accuracy, completeness, or
            reliability of the suggested trips, activities, or any third-party companies or websites mentioned in the
            plans. Users are responsible for their own decisions, actions, and any potential risks associated with
            following the suggested bookings and/or itineraries. We strongly advise users to conduct their own research,
            exercise caution, and adhere to local laws and regulations during their travels.
          </p>

          <h3>I have a question that was not addressed in the FAQs, what should I do?</h3>
          <p>
            If you have a question that we did not answer in these FAQs, please email us at
            <a target="_blank" href="mailto:help@takemobi.com">help@takemobi.com</a> and our support team will be happy
            to assist you.
          </p>
        </div>
        <h2 class="t-center">Preference-Generation Tool FAQ</h2>
        <div>
          <h3>How does the preference-generation tool on the Singapore Trip Planner website work?</h3>
          <p>
            Our preference-generation tool on the website is powered by ChatGPT, an advanced language model developed by
            OpenAI. It uses natural language processing to understand your preferences and provides them to the
            Singapore Trip Planner application, which makes recommendations based on the information you provide.
          </p>

          <h3>What is ChatGPT?</h3>
          <p>
            ChatGPT is an artificial intelligence language model created by OpenAI. It is designed to understand and
            respond to human language, making it capable of assisting with various tasks, including generating
            preferences in our tool.
          </p>

          <h3>How accurate is the output from the preference-generation tool?</h3>
          <p>
            While ChatGPT is an advanced AI language model, the accuracy of its output depends on the data and
            information it receives. It does its best to generate relevant and personalized output, but please note that
            the results may not always be perfect or entirely aligned with your preferences.
          </p>
          <h3>Is Mobi or any other party responsible for output generated by ChatGPT?</h3>
          <p>
            No, Mobi is not responsible for the results generated by ChatGPT. ChatGPT operates independently as an AI
            language model, and its output is based on patterns and data from its training. Mobi utilizes ChatGPT's
            capabilities to enhance your experience, but we cannot guarantee the accuracy or completeness of its
            responses.
          </p>
          <h3>Can I rely solely on the recommendations from the preference-generation tool for decision-making?</h3>
          <p>
            While our preference-generation tool aims to assist you in making choices, we strongly recommend using the
            output as a helpful reference rather than the sole basis for decision-making. Human judgment and context are
            essential for making informed choices, and we encourage you to consider multiple factors before finalizing
            decisions.
          </p>
          <h3>Is my data safe while using the preference-generation tool?</h3>
          <p>
            Yes, we take data privacy and security seriously. Rest assured that any information you provide to the
            preference-generation tool is subject to our <a href="/file/Privacy Policy - Mobi Systems.pdf">Privacy Policy</a>. We do not share your personal data with third
            parties without your consent, and we adhere to strict data protection measures to safeguard your
            information.
          </p>
        </div>
      </div>
    </ModalWrapper>
  </md-modal-dialog>
</template>

<script>
/* eslint-disable */
import {ModalWrapper} from '@mobi-components/amex-bluesky-components';
import '@mobi-components/amex-bluesky-components/dist/amex-bluesky-components.css';
import IconCross from '@components/svg/cross.vue';

import Vue from 'vue';
export default Vue.component('T-C-Dialog', {
  components: {
    ModalWrapper,
    IconCross,
  },
  data() {
    return {
      endDate: 'February 28, 2023',
    };
  },
  methods: {
    onModalClose() {
      this.$modal.submit(null);
    },
  },
});
</script>

<style scoped>
.md-dialog {
  /* --md-theme-default-primary: var(--primary);
  --md-theme-default-primary-on-background: var(--primary);
  --md-theme-default-accent-on-background: transparent;
  --md-theme-default-text-primary-on-accent: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(221, 217, 217, 0.87)
  ); */
  --max-dialog-width: 940px;
}

.modal {
  max-height: 50vh;
  overflow: auto;
}

.btn-close {
  top: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.3s ease background;
  padding: 20px 20px 11px;
  border-radius: 0 19px 0 20px;
  z-index: 1;
  position: absolute;
  font-size: 14px;
  color: #fff;
  appearance: none;
  border: none;
  cursor: pointer;
}
</style>
<style>
.box-wrapper .box {
  padding: 40px;
}
</style>
